/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : 凭证</li>
 * <li>Version     : 1.0</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
	//五险一金列表
	list(params) {
		return Ajax.get("/insure/list", params)
	},
	load(id) {
		return Ajax.get(`/voucher/${id}`)
	},

	edit(params = {}) {
		return Ajax.post(`/insure/edit`, params)
	},
	//销售订单头部统计
	mallOrdertop(params) {
		return Ajax.get("/mallOrder/titleTally", params)
	},
	//销售订单列表
	mallOrderlist(params) {
		return Ajax.get("/mallOrder/list", params)
	},
	//销售汇总表头部统计
	mallOrdersummaryTally(params) {
		return Ajax.get("/mallOrder/summaryTally", params)
	},
	//销售汇总表统计
	mallOrdersummary(params) {
		return Ajax.get("/mallOrder/summary", params)
	},
	//销售数据头部统计（社区）--过时
	mallOrdersummaryRegionTally(params) {
		return Ajax.get("/mallOrder/summaryRegionTally", params)
	},
	//销售数据列表（社区）--过时
	mallOrdersummaryRegion(params) {
		return Ajax.get("/mallOrder/summaryRegion", params)
	},

	//销售数据头部统计（社区） 
	mallOrdersummaryCommunityTally(params) {
		return Ajax.get("/mallOrder/summaryCommunityTally", params)
	},
	//销售数据列表（社区） 
	mallOrdersummaryCommunit(params) {
		return Ajax.get("/mallOrder/summaryCommunity", params)
	},

	//销售数据头部统计（部门/组别）
	mallOrdersummaryGroupTally(params) {
		return Ajax.get("/mallOrder/summaryGroupTally", params)
	},
	//销售数据列表（部门/组别）
	mallOrdersummaryGroup(params) {
		return Ajax.get("/mallOrder/summaryGroup", params)
	},

	//销售数据头部统计（门店）
	mallOrdersummaryStoreTally(params) {
		return Ajax.get("/mallOrder/summaryStoreTally", params)
	},
	//销售数据头部统计（人员）
	mallOrdersummaryPersonTally(params) {
		return Ajax.get("/mallOrder/summaryPersonTally", params)
	},
	//销售数据列表（人员）
	mallOrdersummaryPerson(params) {
		return Ajax.get("/mallOrder/summaryPerson", params)
	},
	//销售数据列表（门店）
	mallOrderSummaryByStore(params) {
		return Ajax.get("/mallOrder/mallOrderSummaryByStore", params)
	},


	
}
